/* eslint-disable import/no-anonymous-default-export */
export default {
  'exception.back': 'Voltar para Início',
  'exception.403.title': 'Desculpe, você não tem acesso a esta página',
  'exception.404': '404',
  'exception.404.title': 'Este link parece não existir mais ou você está perdido',
  'exception.404.message': 'Entre em contato com quem te enviou este link e solicite para verificar',
  'exception.500.title': 'Desculpe, o servidor está reportando um erro',
};
